






































import { Component, Mixins, Watch } from "vue-property-decorator";
import { Action, State } from "vuex-class";

import BaseButton from "@/components/BaseButton/BaseButton.vue";
import AsyncButton from "@/components/BaseAsyncButton/BaseAsyncButton.vue";
import BaseDropdown from "@/components/BaseDropdown/BaseDropdown.vue";
import InputRow from "@/components/InputRow/InputRow.vue";
import AppHeader from "@/components/AppHeader/AppHeader.vue";
import AppHeaderBackWithTitle from "@/components/AppHeader/AppHeaderBackWithTitle.vue";
import AppContent from "@/components/AppContent/AppContent.vue";

import RequestState from "@/utils/mixins/RequestState";

import { ISchool } from "@/models/interfaces/schools";
import { IVuexState } from "@/models/interfaces/store";
import { IClass } from "@/models/interfaces/classes";

@Component({
  components: {
    BaseButton,
    BaseDropdown,
    InputRow,
    AsyncButton,

    AppHeaderBackWithTitle,
    AppHeader,
    AppContent
  }
})
export default class DataSelection extends Mixins(RequestState) {
  @State("schools", { namespace: "schools" })
  private schools!: IVuexState<ISchool[]>;

  @State("classes", { namespace: "classes" })
  private classes!: IVuexState<IClass[]>;

  @Action("schools/fetchSchools")
  private fetchSchools!: () => Promise<{ schools: ISchool[] }>;

  @Action("classes/fetchClassesForSchool")
  private fetchClassesForSchool!: (schoolsIds: string[]) => Promise<IClass[]>;

  public schoolsIds: string[] = [];
  public groupId = "";

  public get schoolsOptions() {
    return this.schools.data?.map(school => ({
      label: school.schoolName,
      value: school.schoolId
    }));
  }

  public get classesOptions() {
    return this.classes.data?.map(classData => ({
      label: classData.className,
      value: classData.classId
    }));
  }

  public mounted() {
    this.fetchSchools();
  }

  @Watch("schoolsIds")
  public onSchoolChange(values: string[]) {
    if (values) {
      this.fetchClassesForSchool(values);
    }
  }
}
